// ⚠️ 此文件由 api:gen 自动生成，请勿手动修改
// 源: capabilities/featured.yaml
// 生成时间: 2026-08-28T07:43:12.569Z
import http from '../http';

export default {
  // 列表 featured.list
  list: (data) => http.get('content-service/aggregatepage/page', data),

  // 聚合页列表 featured.list_org
  list_org: (data) => http.get('content-service/aggregatepage/page_org', data),

  // 详情 featured.get
  get: (id) => http.get('content-service/aggregatepage/' + id),

  // 创建 featured.create
  create: (data) => http.post('content-service/aggregatepage', data),

  // 更新 featured.update
  update: (data) => http.put('content-service/aggregatepage', data),

  // 删除 featured.delete
  delete: (id) => http.delete('content-service/aggregatepage/' + id, {}),

  // 内容来源日志 featured.cntsourcelogs
  cntsourcelogs: (data) => http.post('cmsservice/tracklog/cntsourcelogs', data),
};
